import styles from './header.module.scss';

/**
 * <Header />
 */
const Header = () => (
  <header className={styles.header}>
    <div className={styles.logo} />
  </header>
);

export { Header };
